import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { B } from '../constants';
import { auth } from '../api';

export default function VerifyEmailScreen() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('loading'); // loading | success | error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setStatus('error');
        setMessage('Invalid verification link');
        return;
      }

      try {
        await auth.verifyEmail(token);
        setStatus('success');
        setMessage('Email verified successfully!');
      } catch (err) {
        setStatus('error');
        setMessage(err.message || 'Verification failed. Link may be expired.');
      }
    };

    verify();
  }, [token]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 20,
      background: `linear-gradient(135deg, ${B.night} 0%, #1a3a2a 100%)`,
    }}>
      <div style={{
        background: 'white',
        borderRadius: 24,
        padding: 48,
        maxWidth: 440,
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
      }}>
        {/* Icon */}
        <div style={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          background: status === 'loading' ? `${B.amber}20` : status === 'success' ? `${B.forest}20` : '#ff000020',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 24px',
          fontSize: 36,
        }}>
          {status === 'loading' ? '⏳' : status === 'success' ? '✅' : '❌'}
        </div>

        {/* Title */}
        <h1 style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: 28,
          fontWeight: 700,
          color: B.night,
          marginBottom: 12,
        }}>
          {status === 'loading' ? 'Verifying...' : status === 'success' ? 'Verified!' : 'Verification Failed'}
        </h1>

        {/* Message */}
        <p style={{
          fontFamily: "'Montserrat', sans-serif",
          fontSize: 14,
          color: B.muted,
          lineHeight: 1.6,
          marginBottom: 28,
        }}>
          {message}
        </p>

        {/* Action Button */}
        {status === 'success' && (
          <button
            onClick={() => navigate('/')}
            style={{
              background: B.forest,
              color: 'white',
              border: 'none',
              padding: '14px 32px',
              borderRadius: 50,
              fontSize: 14,
              fontWeight: 700,
              fontFamily: "'Montserrat', sans-serif",
              cursor: 'pointer',
              transition: 'all 0.2s',
            }}
          >
            Continue to GreatBreak ✈️
          </button>
        )}

        {status === 'error' && (
          <div>
            <button
              onClick={() => navigate('/auth')}
              style={{
                background: B.forest,
                color: 'white',
                border: 'none',
                padding: '14px 32px',
                borderRadius: 50,
                fontSize: 14,
                fontWeight: 700,
                fontFamily: "'Montserrat', sans-serif",
                cursor: 'pointer',
              }}
            >
              Go to Sign In
            </button>
          </div>
        )}
      </div>
    </div>
  );
}